import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal appointment-modal" }
const _hoisted_2 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "timeslotCreateModel",
  tabindex: "-1",
  "aria-labelledby": "feedbackModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content shadow-lg mx-3" }
const _hoisted_5 = { class: "shadowed-card bg-white mb-2 p-3 rounded-0" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "text-success text-capitalize" }
const _hoisted_9 = {
  class: "modal-body body-with-datepicker",
  id: "appointmentModelScroll"
}
const _hoisted_10 = { class: "form-wrap" }
const _hoisted_11 = { action: "" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { for: "" }, "title", -1)
const _hoisted_14 = { class: "d-flex" }
const _hoisted_15 = { class: "flex-grow-1" }
const _hoisted_16 = { class: "dropdown color-select-wrap mt-2 ml-2" }
const _hoisted_17 = {
  class: "dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_18 = { class: "dropdown-menu" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#fdc689"}
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#a3d39c"}
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#f49ac1"}
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#6dcff6"}
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#fbe65d"}
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#cba9f8"}
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#fe7a72"}
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#fc95b8"}
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#10d0cf"}
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#00c489"}
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#73d1b5"}
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("span", {
  class: "color-eclipse",
  style: {"background-color":"#fad1e3"}
}, null, -1)
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { for: "" }, "Start date time", -1)
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", { for: "" }, "End date time", -1)
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = /*#__PURE__*/_createVNode("label", { for: "allDay" }, "All Day", -1)
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = /*#__PURE__*/_createVNode("label", { for: "" }, "Invited user", -1)
const _hoisted_42 = { class: "modal-footer bg-white" }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" > ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_AddNotification = _resolveComponent("AddNotification")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeAppointmentModal && _ctx.closeAppointmentModal(...args))),
                class: "close",
                "aria-label": "Close"
              }, [
                _hoisted_6
              ]),
              _createVNode("h1", _hoisted_7, _toDisplayString(_ctx.action) + " Time Slot", 1),
              _createVNode("p", null, [
                _createVNode("small", _hoisted_8, _toDisplayString(_ctx.action) + " Time Slot for Member", 1)
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.errorList,
                hasError: _ctx.state.isErrorStatus
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_10, [
                _createVNode("form", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode("div", _hoisted_14, [
                      _createVNode("div", _hoisted_15, [
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          placeholder: "title",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.title = $event)),
                          disabled: ""
                        }, null, 512), [
                          [_vModelText, _ctx.state.title]
                        ])
                      ]),
                      _createVNode("div", _hoisted_16, [
                        _createVNode("button", _hoisted_17, [
                          _createVNode("span", {
                            class: "color-eclipse",
                            style: `background-color:${_ctx.state.data.bgColor}`
                          }, null, 4)
                        ]),
                        _createVNode("div", _hoisted_18, [
                          _createVNode("a", {
                            class: "dropdown-item color-selected",
                            href: "javascript:void(0)",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.slotcolorSelector('#fdc689')))
                          }, [
                            _hoisted_19
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.slotcolorSelector('#a3d39c')))
                          }, [
                            _hoisted_20
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.slotcolorSelector('#f49ac1')))
                          }, [
                            _hoisted_21
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.slotcolorSelector('#6dcff6')))
                          }, [
                            _hoisted_22
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.slotcolorSelector('#fbe65d')))
                          }, [
                            _hoisted_23
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.slotcolorSelector('#cba9f8')))
                          }, [
                            _hoisted_24
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.slotcolorSelector('#fe7a72')))
                          }, [
                            _hoisted_25
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.slotcolorSelector('#fc95b8')))
                          }, [
                            _hoisted_26
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.slotcolorSelector('#10d0cf')))
                          }, [
                            _hoisted_27
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.slotcolorSelector('#00c489')))
                          }, [
                            _hoisted_28
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.slotcolorSelector('#73d1b5')))
                          }, [
                            _hoisted_29
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.slotcolorSelector('#fad1e3')))
                          }, [
                            _hoisted_30
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_31, [
                    _createVNode("div", _hoisted_32, [
                      _createVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createVNode(_component_v_date_picker, {
                          modelValue: _ctx.state.data.range.start,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.state.data.range.start = $event)),
                          mode: "dateTime"
                        }, {
                          default: _withCtx(({ inputValue, inputEvents }) => [
                            _createVNode("input", _mergeProps({
                              class: "px-2 py-1 border rounded focus:outline-none focus:border-blue-300",
                              value: inputValue
                            }, _toHandlers(inputEvents)), null, 16, ["value"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_35, [
                      _createVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createVNode(_component_v_date_picker, {
                          modelValue: _ctx.state.data.range.end,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.data.range.end = $event)),
                          mode: "dateTime"
                        }, {
                          default: _withCtx(({ inputValue, inputEvents }) => [
                            _createVNode("input", _mergeProps({
                              class: "px-2 py-1 border rounded focus:outline-none focus:border-blue-300",
                              value: inputValue
                            }, _toHandlers(inputEvents)), null, 16, ["value"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_38, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      id: "allDay",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.data.allDay = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.data.allDay]
                    ]),
                    _hoisted_39
                  ]),
                  _createVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.data.invitedUser = $event)),
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.invitedUser]
                    ])
                  ]),
                  _createVNode(_component_AddNotification, {
                    notifications: _ctx.state.data.notifications,
                    onNotificationList: _ctx.updateNotificationList
                  }, null, 8, ["notifications", "onNotificationList"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                (_ctx.action === 'new')
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      class: "btn default-btn mr-3",
                      type: "submit",
                      onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.saveAppointment && _ctx.saveAppointment(...args)))
                    }, _toDisplayString(_ctx.state.postLoadingCreateAppointmen ? "Creating..." : "Add"), 1))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      class: "btn default-btn mr-3",
                      type: "submit",
                      onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.saveAppointment && _ctx.saveAppointment(...args)))
                    }, _toDisplayString(_ctx.state.postLoadingCreateAppointmen ? "updating..." : "Update"), 1)),
                _createVNode("button", {
                  class: "btn secondary-btn",
                  type: "submit",
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.closeAppointmentModal && _ctx.closeAppointmentModal(...args)))
                }, " Cancel ")
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.SuccessFulMessage
        }, {
          default: _withCtx(() => [
            _hoisted_44
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}